export default __webpack_public_path__ + "static/Entenda0141-2ea90ab9566b9d1564d53b101daa8793.jpg";